import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { createTimeline, getTimelines } from 'redux/actions/timelineActions';
import { flattenKeyPairArray } from 'utils/misc';
import { get } from 'lodash';
import PageTitle from 'components/titles/PageTitle';
import TimelineFilter from 'components/filters/TimelineFilter';
import NotificationSystem from 'rc-notification';
import BasicNotification from 'components/Notification';
import { NOTIFICATION_NODE_STYLE } from 'constants/misc';
import TimelineList from './TimelineList';


const Timeline = (props) => {
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    NotificationSystem.newInstance({}, n => setNotification(n));
    return () => (notification ? notification.destroy() : null);
  }, []);

  const showSuccessNotification = () => (
    notification.notice({
      content: <BasicNotification
        color="success"
        message="Timeline generated successfully."
      />,
      duration: 2,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    })
  );

  const showErrorNotification = msg => (
    notification.notice({
      content: <BasicNotification
        color="danger"
        message={msg}
      />,
      duration: 2,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    })
  );

  const onSubmit = async (formData) => {
    const payload = {
      account: formData.account.value,
      campaigns: flattenKeyPairArray(formData.campaigns || [], 'value'),
      email_service_provider_configs: flattenKeyPairArray(formData.emails || [], 'value'),
      launch_date__gte: formData.launchDate.startDate,
      launch_date__lt: formData.launchDate.endDate,
    };
    try {
      await props.createTimeline(payload);
      showSuccessNotification();
      props.getTimelines();
    } catch (err) {
      const msg = get(err, 'errors.non_field_errors[0]');
      if (msg) {
        showErrorNotification(msg);
      }
    }
  };
  return (
    <Container>
      <PageTitle className="mb-3">Timeline</PageTitle>
      <Row>
        <Col>
          <TimelineFilter onSubmit={onSubmit} />
          <TimelineList />
        </Col>
      </Row>
    </Container>
  );
};

Timeline.propTypes = {
  createTimeline: PropTypes.func.isRequired,
  getTimelines: PropTypes.func.isRequired,
};

export default connect(() => {}, { createTimeline, getTimelines })(Timeline);
